import { WebApiModel } from './web-api.model';

export class Profile {
  data: WebApiModel.ProfileDetail;
  type: string;
}
